/* eslint-disable react-hooks/exhaustive-deps */
// wijmo

import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Button, Col, Container, Row, Table } from "react-bootstrap"
import TextInput from "../../../components/InputWrapper/TextInput"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { ModalOuter, TModalTypes } from "../../../components/Modal/ModalOuter"
import dayjs from "dayjs"
import { setAlerts } from "../../../globalStore/alertStore"
import { AppDispatch } from "../../.."
import sogoYusoKaigiService from "../../../service/budget/sogoYusoKaigi/sogoYusoKaigiService"
import { TBudgetAchievementlistGetReq } from "../../../service/budget/sogoYusoKaigi/TSogoYusoKaigi"

/**
 * 手当情報修正モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const CreateGekkanSyukeiModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    年月: string
    setIsEdited: (value: boolean) => unknown
  }
> = (props) => {
  const dispatch: AppDispatch = useDispatch()
  //#region [state]

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]

  const beforeSubmit = () => {
    setIsConfirmModalShow(true)
  }

  const submit = async () => {
    setAlertSource(undefined)
    try {
      const service = new sogoYusoKaigiService()
      const cond: TBudgetAchievementlistGetReq = {
        年月: props.年月,
        年: dayjs(props.年月).year(),
        月: dayjs(props.年月).month() + 1,
      }
      let res = await service.postCreateGekkanSyukei(cond)
      if (res.data) {
        props.setIsShow(false)
        props.setIsEdited(true)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (props.isShow) {
    }
  }, [props.isShow])
  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "月間集計"}
      setIsShow={props.setIsShow}
      size={"sm"}
      footer={
        <Button
          type="submit"
          variant="waiting"
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            beforeSubmit()
          }}>
          処理実行
        </Button>
      }>
      <Container fluid className="label-form">
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <Table className="form-table">
                <tbody>
                  <tr>
                    <th className="min-w-8rem">日付</th>
                    <td>
                      <div className="input-group">
                        <TextInput
                          style={{ width: "8rem" }}
                          id="日付"
                          name="日付"
                          value={dayjs(props.年月).format("YYYY/MM")}
                          isReadOnly={true}
                          setValue={() => {}}
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </form>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default CreateGekkanSyukeiModal
